import {Routes} from '@angular/router';
import {SecureComponent} from './secure.component';
import {NewProductComponent} from './products/new-product/new-product.component';
import {UpdateProductComponent} from './products/update-product/update-product.component';
import {DashboardComponent} from './dashboard/dashboard.component';
import {AuthGuard} from '../@shared/authentication/auth.guard';
import {RfqsComponent} from './dashboard/rfqs/rfqs.component';
import {DashboardContentComponent} from './dashboard/content/dashboard-content.component';
import {RfqComponent} from './dashboard/rfqs/rfq/rfq.component';
import {QuotationComponent} from './dashboard/rfqs/quotation/quotation.component';

export const SecureRoutes: Routes = [
    {
        path: '',
        component: SecureComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: 'new-product',
                component: NewProductComponent
            },
            {
                path: 'update-product/:id',
                component: UpdateProductComponent
            },
            {
                path: 'dashboard',
                component: DashboardComponent,
                children: [
                    {
                        path: '',
                        component: DashboardContentComponent
                    },
                    {
                        path: 'rfqs',
                        children: [
                            {
                                path: '',
                                component: RfqsComponent,
                                pathMatch: 'full'
                            },
                            {
                                path: ':number',
                                children: [
                                    {
                                        path: '',
                                        component: RfqComponent,
                                        pathMatch: 'full'
                                    },
                                    {
                                        path: ':number',
                                        children: [
                                            {
                                                path: '',
                                                component: QuotationComponent,
                                                pathMatch: 'full'
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }
];
